// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Logo-style__wrapper__fdc13700","icon":"Logo-style__icon__fdc13700"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo-style.scss
// module id = ./src/components/Logo/Logo-style.scss
// module chunks = 4